/**
 * @file
 * Behaviors for Statistics.
 */

/* eslint-disable max-len */
!(function(document, Drupal) {
  'use strict';
  /**
   * Setup and attach the Statistic behaviors.
   *
   * @type {Drupal~behavior}
   */

  Drupal.behaviors.statistic = {
    attach: function attach(context) {
      var $$statistics = context.querySelectorAll('.statistic');

      // Using IntersectionObserver to set every stat to 0 when offscreen, and
      // to the target number when it scrolls on screen, so get the proper
      // odometer animation.
      let observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            const el = entry.target;
            const number = el.querySelector('.statistic__number');

            if (entry.isIntersecting) {
              // Actual value is always stored in the data-number attribute.
              number.innerHTML = parseFloat(el.getAttribute('data-number'));
              // Don't animate more than once.
              observer.unobserve(el);
            }
            else {
              number.innerHTML = '0';
            }
          });
        },
        // React only when number moves completely outside or completely into viewport.
        { threshold: [0, 1] }
      );

      $$statistics.forEach((el) => {
        const number = el.querySelector('.statistic__number');
        // Animate everything on load, for stats already above the fold.
        number.innerHTML = '0';
        number.innerHTML = el.querySelector('.statistic__number');
        // Start observing; this instantly zeroes anything that starts offscreen.
        observer.observe(el);
      });
    }
  };
})(document, Drupal);
//# sourceMappingURL=statistic.es6.js.map
